import React from 'react';
import { motion } from 'framer-motion';
import { responsiveImg } from '../../lib/imageUrl';
import { useSlotImage } from '../../lib/useSlotImage';
import { useText } from '../../lib/siteContent';
import { UniverseLinks } from './UniverseLinks';

const MAIN_FALLBACK = 'https://images.unsplash.com/photo-1738669635055-747b330c046e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920';

const SERVICES = [
  { n: '01', title: 'Conception & direction artistique', desc: 'Intention, palette, matières et langage visuel.' },
  { n: '02', title: 'Planification', desc: 'Calendrier, budget, échéances et déroulement.' },
  { n: '03', title: 'Lieux & prestataires', desc: 'Recherche, sélection et coordination.' },
  { n: '04', title: 'Scénographie & décoration', desc: 'Floraux, tables, lumière, mobilier et papeterie.' },
  { n: '05', title: 'Coordination du jour J', desc: 'Installation, prestataires et temps forts.' },
  { n: '06', title: 'Destination Wedding', desc: 'Europe et international.' },
];

const ease = [0.22, 1, 0.36, 1];

const ServiceItem = ({ s, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-40px' }}
    transition={{ duration: 0.9, delay: (i % 3) * 0.1, ease }}
    className="border-t border-[#111111]/15 pt-8"
    data-testid={`wedding-service-${s.n}`}
  >
    <span className="block text-[11px] tracking-[0.3em] text-[#6B6B6B]">{s.n}</span>
    <h3 className="mt-5 font-serif font-light text-[#111111] text-2xl md:text-[1.75rem] leading-[1.2]">{s.title}</h3>
    <p className="mt-4 text-sm leading-[1.85] font-light text-[#333333] max-w-xs">{s.desc}</p>
  </motion.div>
);

export const WeddingsContent = () => {
  const image = useSlotImage('weddings-main', MAIN_FALLBACK);
  const t = useText();
  return (
    <main data-testid="universe-page-weddings">
      <section className="container-custom pt-20 md:pt-32 pb-16 md:pb-24">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, ease }}>
          <span className="block text-[11px] uppercase tracking-[0.3em] text-[#6B6B6B] mb-8 md:mb-10" data-testid="universe-label">
            {t('weddings.label')}
          </span>
          <h1 className="font-serif font-light text-[#111111] text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] leading-[1.04] max-w-5xl" data-testid="universe-title">
            <span className="whitespace-pre-line">{t('weddings.headline')}</span>
          </h1>
        </motion.div>
      </section>

      <section className="container-custom">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1.4, delay: 0.3 }} className="w-full aspect-[4/3] sm:aspect-[16/9] lg:aspect-[2/1] overflow-hidden bg-[#F5F5F5]">
          <img {...responsiveImg(image, '(max-width: 768px) 100vw, 50vw', { eager: true })} alt="Réception de mariage — image d'illustration" className="w-full h-full object-cover" data-testid="universe-hero-image" />
        </motion.div>
      </section>

      <section className="container-custom pt-24 md:pt-36" data-testid="wedding-services">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-12 xl:gap-x-20 gap-y-16 md:gap-y-24">
          {SERVICES.map((s, i) => ({ ...s, title: t(`weddings.s${i + 1}.title`), desc: t(`weddings.s${i + 1}.desc`) })).map((s, i) => <ServiceItem key={s.n} s={s} i={i} />)}
        </div>
      </section>

      <UniverseLinks />
    </main>
  );
};
